import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';
import { trackPageView, trackAppDownload } from '../utils/analytics';

const DownloadContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%);
  color: white;
  padding: 40px 20px;
`;

const DownloadContent = styled.div`
  text-align: center;
  max-width: 600px;
  width: 100%;
`;

const DownloadTitle = styled.h1`
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 24px;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
  
  @media (max-width: 480px) {
    font-size: 28px;
  }
`;

const DownloadSubtitle = styled.p`
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 40px;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const LoadingText = styled.p`
  font-size: 18px;
  margin-bottom: 20px;
  opacity: 0.8;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top: 4px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const DownloadPage: React.FC = () => {
  useEffect(() => {
    // 다운로드 페이지 방문 추적
    trackPageView('Download Page');

    // URL 파라미터에서 플랫폼 정보 가져오기
    const urlParams = new URLSearchParams(window.location.search);
    const platform = urlParams.get('platform') as 'google_play' | 'app_store';
    const storeUrl = urlParams.get('url');

    if (platform && storeUrl) {
      // 플랫폼별 다운로드 추적
      trackAppDownload(platform);

      // Google Ads 전환 추적
      if (typeof window !== 'undefined' && window.gtag_report_conversion) {
        window.gtag_report_conversion(storeUrl);
      }

      // 2초 후 실제 스토어로 리다이렉트
      setTimeout(() => {
        window.location.href = decodeURIComponent(storeUrl);
      }, 2000);
    } else {
      // 파라미터가 없으면 메인 페이지로 리다이렉트
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);
    }
  }, []);

  return (
    <DownloadContainer>
      <DownloadContent>
        <DownloadTitle>
          앱 다운로드 중...
        </DownloadTitle>
        <DownloadSubtitle>
          잠시만 기다려주세요. 곧 앱스토어로 이동합니다.
        </DownloadSubtitle>

        <Spinner />
        <LoadingText>
          리다이렉트 중...
        </LoadingText>
      </DownloadContent>
    </DownloadContainer>
  );
};
